/** @format */

const template = `
<div class="search-filter">
  <ng-form name="filterSelectorForm">
    <div class="input-group">
      <div class="row">
        <div class="col-9">
          <local-date-editor
            data-cy="filter-date-editor"
            name="localDate"
            local-date="ctrl.clonedParameterModel.value.localDate"
            min-date="ctrl.minDate"
            hide-labels="true">
          </local-date-editor>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ul
          ng-if="filterSelectorForm.$invalid"
          class="error-list"
          ng-messages="filterSelectorForm.localDate.$error"
          ng-messages-multiple="true"
          role="alert">
          <li ng-message="required" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE_IS_REQUIRED </li>
          <li ng-message="date, parse, pattern" translate>SIS_COMPONENTS.COMMON_VALIDATION_ERRORS.LOCAL_DATE </li>
          <li ng-message="minDate"> {{'SIS_COMPONENTS.COMMON_VALIDATION_ERRORS.MIN_DATE' | translate : ctrl.minDateTranslateData()}} </li>
        </ul>
      </div>
    </div>
    <div class="row filter-preview-row">
      <div class="col-9">
        <div class="filter-preview-holder">
          <span class="filter-preview-title">{{ctrl.filterName}}</span>
          <span class="filter-preview-content">{{ctrl.clonedParameterModel.displayValue()}}</span>
        </div>
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="btn btn-lg btn-primary filter-submit"
          ng-click="ctrl.submitFilter()"
          ng-disabled="filterSelectorForm.$pristine || filterSelectorForm.$invalid"
          translate="SEARCH.FILTER_SELECTOR.OK">
        </button>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
